// extracted by mini-css-extract-plugin
export default {"candidati":"style_candidati__dND4y","namesContainer":"style_namesContainer__BxIy3","names":"style_names__ngiiQ","logo":"style_logo__7nRwG","removedUser":"style_removedUser__zpZg-"};